import { connect } from 'react-redux';
import HelpPage from './HelpPage';
import { requestChat } from '../../redux/common/actions';

const actions = {
  requestChat,
};

export default connect(null, actions)(HelpPage);
